import React from 'react'
import { LangSteps33 } from '../../../constant/languange'
import Content from '../Content'

const Third3 = (props) => {
  const data = {
    title: '',
    steps: [LangSteps33],
    button: 'Mulai Tambah Karyawan',
    nextStep: 4,
    skipTo: '/personnel/work/time',
    isDone: props.stats.personnels_count
  }

  return <Content {...props} data={data} />
}

export default Third3
